import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo-bottom.png';
const _withScopeId = n => (_pushScopeId("data-v-7d7d24be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" 成都义信东合文化传播有限公司 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("地址：成都市武侯区双楠小区龙门巷61号5栋1层16号 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("邮编：610000 ")])], -1));
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index"
}, "网站备案/许可证：蜀ICP备17020190号"), /*#__PURE__*/_createTextVNode(" 丨 网络文化经营许可证：川网文[2020]3010-612号")]), /*#__PURE__*/_createElementVNode("p", null, "成都义信东合文化传播有限公司")], -1));
export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: "/agreement"
  }, {
    default: _withCtx(() => [_createTextVNode("用户协议")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/privacy"
  }, {
    default: _withCtx(() => [_createTextVNode("隐私政策")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/minority"
  }, {
    default: _withCtx(() => [_createTextVNode("未成年人隐私政策保护")]),
    _: 1
  }), _createVNode(_component_router_link, {
    to: "/dispute"
  }, {
    default: _withCtx(() => [_createTextVNode("纠纷处理")]),
    _: 1
  })])]), _hoisted_4]);
}